<template>
  <b-modal :active="show" @close="requestClose" :width="620">
    <div class="modal-card" style="padding-bottom:3rem;">
      <div class="modal-card-head">
        <div class="modal-card-title">Mehrfach Anlage</div>
      </div>
      <div class="modal-card-body" style="overflow-y:scroll !important;">
        <section v-show="!codes || codes.length == 0">
          <b-field label="Name" horizontal>
            <b-input
              v-model="reduction.name"
              required
              placeholder="Name des Promotioncodes"
            ></b-input>
          </b-field>
          <b-field label="Gruppe" horizontal>
            <b-input
              v-model="reduction.group"
              placeholder="Promotioncode Gruppe"
            ></b-input>
          </b-field>
          <b-field label="Anzahl" horizontal>
            <b-numberinput
              type="is-light"
              min="1"
              v-model="reduction.count"
              required
            ></b-numberinput>
          </b-field>
          <b-field label="Gültig bis" horizontal>
            <b-datepicker
              placeholder="Gültigkeit wählen"
              required
              v-model="reduction.dates"
              range
            ></b-datepicker>
          </b-field>
          <div v-if="type === 'p'">
            <b-field label="Prozent" horizontal>
              <b-numberinput
                type="is-light"
                v-model="reduction.percentage"
                min="1"
                max="99"
              ></b-numberinput>
            </b-field>
          </div>
          <div>
            <b-field v-if="type === 'f'" label="Betrag in €" horizontal>
              <b-input
                type="number"
                icon="euro-sign"
                v-model="reduction.amount"
                min="1"
              ></b-input>
              <!-- <b-numberinput
                type="is-light"
                v-model="reduction.amount"
                min="1"
              ></b-numberinput> -->
            </b-field>
          </div>
        </section>
        <div v-show="codes">
          <pre style="max-height: 400px;">{{ codes }}</pre>
        </div>
      </div>
      <footer class="modal-card-foot">
        <b-button type="is-text" v-show="codes" @click="close" expanded
          >Schließen</b-button
        >
        <b-button type="is-text" v-show="!codes" @click="cancel" expanded
          >Abbrechen</b-button
        >
        <b-button
          type="is-primary"
          v-show="!codes"
          @click="saveReduction"
          expanded
          >Anlegen</b-button
        >
      </footer>
    </div>
    <b-loading
      :is-full-page="false"
      :active.sync="loading"
      :can-cancel="false"
    ></b-loading>
  </b-modal>
</template>

<script>
import reductionApi from '@/api/reduction-api'
export default {
  name: 'BatchCreateReductionsModal',
  props: {
    type: String,
    show: Boolean,
  },
  data() {
    return {
      reduction: {
        name: '',
        code: '',
        dates: [],
        percentage: 1,
        amount: 1,
        count: 1,
      },
      loading: false,
      codeMessage: '',
      valid: false,
      result: [],
      codes: '',
    }
  },
  mounted() {},
  methods: {
    async saveReduction() {
      if (
        this.reduction.count > 0 &&
        this.reduction.name &&
        this.reduction.dates.length == 2
      ) {
        let dto = {
          name: this.reduction.name,
          count: this.reduction.count,
          validFrom: this.reduction.dates[0],
          validTo: this.reduction.dates[1],
          group: this.reduction.group,
        }
        this.loading = true
        if (this.type === 'p') {
          dto.percentage = this.reduction.percentage / 100
          let res = await reductionApi.createPercentageTanReductions(dto)
          this.$buefy.toast.open('Angelegt')
          this.result = res
          //this.$emit('close', res)
        }
        if (this.type === 'f') {
          ;(dto.currency = 'EUR'), (dto.amount = this.reduction.amount)
          let res = await reductionApi.createFixedTanReductions(dto)
          this.$buefy.toast.open('Angelegt')
          this.result = res
        }
        let codes = ''
        for (let i = 0; i < this.result.length; i++) {
          codes += this.result[i].code + '\r\n'
        }
        this.codes = codes
        this.loading = false
      } else {
        this.$buefy.toast.open('Bitte prüfen Sie Ihre Eingaben!')
      }
    },
    cancel() {
      this.$emit('close')
      this.codes = ''
    },
    close() {
      this.$emit('close', this.result)
      this.codes = ''
    },
    requestClose() {
      this.$emit('close')
      this.codes = ''
    },
  },
}
</script>

<style lang="scss">
.modal-content {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.modal-card,
.modal-content {
  width: auto;
}

.modal,
.modal-card,
.modal-card-body,
.modal-content {
  overflow: visible !important; //to show datepicker on desktop
}
</style>
